/// <reference path="../include.ts" />

namespace project_guide {

	import Scene = scn.Scene;
	import Dom = alm.util.Dom;
	import DataParser = project_common.DataParser;
	import CurrentState = project_common.CurrentState;

	export class ZoneScene extends Scene {

		// --------------------------------------------------
		//
		// CONSTRUCTOR
		//
		// --------------------------------------------------

		constructor(zoneId:string) {
			super(zoneId);
		}





		// --------------------------------------------------
		//
		// METHOD
		//
		// --------------------------------------------------

		protected implOnLoad():cmd.Command {
			return new cmd.Func(():void => {
				trace('[ZoneScene ' + this.getName() + '] load');

				// set current context
				const message = <SceneTransferMessage>this.getTransferInfo().message;
				const currentState = message.currentState;

				currentState.currentZone = DataParser.getZoneFromArea(currentState.currentArea, this.getName());
				this.currentState = currentState;

				/*
				// card view
				{
					const cardView = CardView.getInstance();
					cardView.addEventListener(CardViewEvent.REQUIRE_CLOSE, this.cardViewRequireCloseHandler);
					cardView.setContext(currentState.currentRegion, currentState.currentZone);
					cardView.show();
				}
				*/
			});
		}

		protected implOnUnload():cmd.Command {
			return new cmd.Func(():void => {
				trace('[ZoneScene ' + this.getName() + '] unload');

				// clear current context
				const message = <SceneTransferMessage>this.getTransferInfo().message;
				const currentState = message.currentState;

				currentState.currentZone = null;
				this.currentState = null;

				// remove self from scene tree
				this.getParent().removeChild(this);

				/*
				// card view
				{
					const cardView = CardView.getInstance();
					cardView.removeEventListener(CardViewEvent.REQUIRE_CLOSE, this.cardViewRequireCloseHandler);
					cardView.clearContext();
					cardView.hide();
				}
				*/
			});
		}

		protected implOnArrive():cmd.Command {
			return new cmd.Func(():void => {
				trace('[ZoneScene ' + this.getName() + '] arrive');

				const message = <SceneTransferMessage>this.getTransferInfo().message;

				// set scroll
				if (message.scroll) {
					Dom.scrollTo(0, message.smoothScroll);
				}
			});
		}

		protected implOnLeave():cmd.Command {
			return new cmd.Func(():void => {
				trace('[ZoneScene ' + this.getName() + '] leave');
			});
		}

		protected implOnAscend():cmd.Command {
			return new cmd.Func(():void => {
				trace('[ZoneScene ' + this.getName() + '] ascend');
			});
		}

		protected implOnDescend():cmd.Command {
			return new cmd.Func(():void => {
				trace('[ZoneScene ' + this.getName() + '] descend');
			});
		}





		/*
		private cardViewRequireCloseHandler = (event:CardViewEvent):void => {
			const path = '/' + this.context.currentRegion.urn + '/' + this.context.currentArea.urn;
			this.gotoScene(path, new SceneTransferMessage(this.context, false, false));
		};
		*/





		// --------------------------------------------------
		//
		// MEMBER
		//
		// --------------------------------------------------

			private currentState:CurrentState;
	}
}
